import { AccountType } from '@shared/enums';

export interface BaseAccount {
  id?: string;
  firstName: string;
  lastName: string;
  accountType: AccountType;
  email: string;
}
